import Button from "elements/Button";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { logout } from "store/actions/authAction";

export default function UserDropdown() {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.authReducer);

  const handleLogout = () => {
    dispatch(logout());
  };
  return (
    <div className="dropdown">
      <button
        className="btn dropdown-toggle d-flex align-items-center justify-content-center"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="fa-solid fa-user fa-lg"></i>
        <p className="user">{user && user.name}</p>
      </button>
      <ul className="dropdown-menu">
        <li>
          <NavLink className="dropdown-item" to="/profile">
            Profile
          </NavLink>
        </li>
        {user && user.role === "SELLER" ? (
          <li>
            <Button
              type="link"
              href="/seller"
              className="btn dropdown-item mt-2"
              isSecondary
              isBlock
            >
              Seller Center
            </Button>
          </li>
        ) : (
          <>
            <li>
              <NavLink className="dropdown-item" to="/wishlist">
                Wishlist
              </NavLink>
            </li>
            <li>
              <NavLink className="dropdown-item" to="/history">
                Riwayat Transaksi
              </NavLink>
            </li>
          </>
        )}
        <li>
          <Button
            type="button"
            href="/logout"
            className="btn dropdown-item mt-2"
            isPrimary
            isBlock
            onClick={handleLogout}
          >
            Log Out
          </Button>
        </li>
      </ul>
    </div>
  );
}
